import * as React from "react";

const DocumentIcon = ({ color = "currentColor", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0968 14.0195H7.08017" stroke={color} strokeWidth="1.5" strokeLinecap="round"
          strokeLinejoin="round"
    />
    <path d="M13.0968 10.5308H7.08017" stroke={color} strokeWidth="1.5" strokeLinecap="round"
          strokeLinejoin="round"
    />
    <path d="M9.37608 7.05005H7.08025" stroke={color} strokeWidth="1.5" strokeLinecap="round"
          strokeLinejoin="round"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M13.2572 2.7915C13.2572 2.7915 6.85967 2.79484 6.84967 2.79484C4.54967 2.809 3.1255 4.32234 3.1255 6.63067V14.294C3.1255 16.614 4.5605 18.1332 6.8805 18.1332C6.8805 18.1332 13.2772 18.1307 13.288 18.1307C15.588 18.1165 17.013 16.6023 17.013 14.294V6.63067C17.013 4.31067 15.5772 2.7915 13.2572 2.7915Z"
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

export default DocumentIcon;